import React, { useMemo, useEffect, useRef } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import _ from "lodash";
import { useGridData } from "../GridDataContext";
import { useDidMount } from "../../utils/hooks";

/**
 * Edit dropdown cell component
 * @module
 * @param {func} getProps - Get props function
 * @param {func} getColumns - Get columns function
 */
export const editDropdownCell = ({ getColumns, isValueChanged }) => {
  const EditDropdownCell = (props) => {
    const { onChange, dataItem, field, tdProps, isInEdit } = props;
    const schemaItem = useMemo(() => getColumns().find((item) => item.field === field), [field])
    const { textField, data: dataField, onChange: onChangeField, primaryField } = schemaItem;

    const data = useGridData(dataField)?.data;
    const onChangeData = useGridData(onChangeField);

    useDidMount(() => {
      if (data && data.data?.length === 0) {
        onChangeData({ filters: [] }, { skip: 0, take: 100 }, [], primaryField);
      }
    })

    //test
    const dropDownRef = useRef(null);
    
    useEffect(() => {
      if (dropDownRef.current && dropDownRef.current.element && props.name) {
        dropDownRef.current.element.setAttribute('data-testid', props.name);
      }
    }, [props.name])

    const handleChange = (e) => {
      onChange({
        dataItem: dataItem,
        field: field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    };

    const dataValue = _.get(dataItem, field);

    return <td
      {...tdProps}
      className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`}
      tabIndex={0}
    >
      {isInEdit ? (
        <DropDownList
          onChange={handleChange}
          value={dataValue && primaryField !== undefined && data ? data.find((c) => c[primaryField] === dataValue[primaryField]) : ""}
          data={data || []}
          textField={textField}
          ref={dropDownRef}
        />
      ) : dataValue ? (
        dataValue[textField]
      ) : (
        ""
      )}
    </td>

  };

  return EditDropdownCell;
};
